import { Component } from '@angular/core';
import { AlertBasicConfirmDialogComponent } from '../../../../shared/components/alert-basic-confirm-dialog/alert-basic-confirm-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ble-permissions-dialog',
  standalone: true,
  imports: [],
  templateUrl: './ble-permissions-dialog.component.html',
  styleUrl: './ble-permissions-dialog.component.scss'
})
export class BlePermissionsDialogComponent {
  constructor(public dialogRef: MatDialogRef<AlertBasicConfirmDialogComponent>) {}

  onConfirmClick() {
    this.dialogRef.close('confirm');
  }
}
